import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { FilterCheckBox } from '../FilterCheckBox'

import styles from './HomeType.module.scss'
import { PropertyType } from '../../../../api/gqlaxy/gql/generated/graphql'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.homeType.heading',
    defaultMessage: 'Home type'
  },
  condo: {
    id: 'HomeSearch.listings.filters.homeType.condo',
    defaultMessage: 'Condo'
  },
  house: {
    id: 'HomeSearch.listings.filters.homeType.house',
    defaultMessage: 'House'
  },
  lotsland: {
    id: 'HomeSearch.listings.filters.homeType.lotLand',
    defaultMessage: 'Lots / Land'
  },
  manufactured: {
    id: 'HomeSearch.listings.filters.homeType.manufactured',
    defaultMessage: 'Manufactured'
  },
  other: {
    id: 'HomeSearch.listings.filters.homeType.other',
    defaultMessage: 'Other'
  },
  townhome: {
    id: 'HomeSearch.listings.filters.homeType.townhome',
    defaultMessage: 'Townhome'
  },
  multifamily: {
    id: 'HomeSearch.listings.filters.homeType.multifamily',
    defaultMessage: 'Multi Family'
  }
})

const HOME_TYPES = [
  PropertyType.House,
  PropertyType.Townhome,
  PropertyType.Condo,
  PropertyType.Manufactured,
  PropertyType.LotsLand,
  PropertyType.MultiFamily,
  PropertyType.Other
]

export interface HomeTypeProps {
  selectedHomeTypes: string[]
  onSetSelectedHomeTypes: (selected: string[]) => void
}

export const HomeType = ({ selectedHomeTypes, onSetSelectedHomeTypes }: HomeTypeProps) => {
  const intl = useIntl()

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <fieldset className={styles.checkBoxFields}>
        {HOME_TYPES.map(type => (
          <FilterCheckBox
            key={type}
            isChecked={selectedHomeTypes.includes(type)}
            name={type}
            onChange={() => {
              if (selectedHomeTypes.includes(type)) {
                onSetSelectedHomeTypes(selectedHomeTypes.filter(selectedType => selectedType !== type))
              } else {
                onSetSelectedHomeTypes([...selectedHomeTypes, type])
              }
            }}
            label={intl.formatMessage(MSG[type.toLowerCase()])}
          />
        ))}
      </fieldset>
    </FilterSection>
  )
}
